import React, { memo } from "react";
import ReactDOM from "react-dom";

import { ModalBackgroundStyled } from "../common/ModalComponent/styles";
import { OptionsDropdownProps, RowData } from "./types";
import { DropdownElementStyled, DropdownStyled } from "./styles";

type OptionsDropdownComponent = <T extends RowData>(
  props: OptionsDropdownProps<T>
) => JSX.Element | null;

export const OptionsDropdown: OptionsDropdownComponent = memo(
  ({
    toggleDropdown,
    optionsButtonRef,
    options,
    item,
    optionsDropdownOffset = { top: 0, right: 0 },
  }) => {
    const boundingOptionsButtonRect =
      optionsButtonRef.current?.getBoundingClientRect();
    const dropdownTopOffset = boundingOptionsButtonRect?.top;
    const dropdownRightOffset =
      document.body.clientWidth - (boundingOptionsButtonRect?.right || 0);
    const handleClick = (
      callback: (param: typeof item) => void,
      e: React.MouseEvent
    ) => {
      e.stopPropagation();
      callback(item);
      toggleDropdown();
    };

    // Find the appropriate container for the portal
    const getPortalContainer = () => {
      // Try to find ListWrapper first (for NewList components)
      let container = document.getElementById("ListWrapper");

      // If not found, try QueueManagerWrapper (for Queue Manager)
      if (!container) {
        container = document.getElementById("QueueManagerWrapper");
      }

      // Fallback to document.body if neither is found
      return container || document.body;
    };

    return ReactDOM.createPortal(
      Array.isArray(options) && (
        <>
          <ModalBackgroundStyled
            onClick={(e) => {
              e.stopPropagation();
              toggleDropdown();
            }}
            isTransparent={true}
          />
          <DropdownStyled
            topOffset={dropdownTopOffset}
            rightOffset={dropdownRightOffset}
            optionsDropdownOffset={optionsDropdownOffset}
          >
            {options
              .filter(({ isHide }) => !isHide?.(item))
              .map(({ name, callback, dataTestId }) => (
                <DropdownElementStyled
                  key={name}
                  data-test-id={
                    dataTestId ||
                    `action-${name.toLowerCase().replace(/\s+/g, "-")}`
                  }
                  onClick={(e) => handleClick(callback, e)}
                >
                  {name}
                </DropdownElementStyled>
              ))}
          </DropdownStyled>
        </>
      ),
      getPortalContainer()
    );
  }
);
